const styles = {
  MuiButton: {
    styleOverrides: {
      root: {
        borderRadius: "100px",
        minWidth: "56px",
        padding: "6px 12px",
        textTransform: "none",
        lineHeight: "142.857%",
        fontSize: "var(--text-body-1)",
        "& ,&:hover": {
          boxShadow: "none",
        },
        "&.MuiButton-containedInherit": {
          backgroundColor: "var(--gray-1)",
        },
        "&.MuiButton-containedInherit:hover": {
          backgroundColor: "var(--divider-main)",
        },
        "&.MuiButton-textSecondary": {
          color: "var(--gray-5)",
        },
        "&.MuiButton-textSecondary:hover": {
          backgroundColor: "var(--primary-light)",
        },
      },
    },
  },
};

export default styles;
